import type React from 'react';
import type { ReactNode } from 'react';
import styles from './index.module.scss';

export type CharacterMessageProps = {
  children: ReactNode;
  /**
   * - 'center': アイコンと吹き出しを中央揃え（固定文言などの1行のメッセージ向け）
   * - 'top': アイコンを上揃え + padding-top: 24px（全体サマリーなどの長いメッセージ向け）
   */
  variant: 'center' | 'top';
  characterImageUrl?: string;
};

export const CharacterMessage: React.FC<CharacterMessageProps> = ({
  children,
  variant,
  characterImageUrl,
}) => {
  return (
    <div
      className={`${styles.container} ${variant === 'top' ? styles.containerTop : styles.containerCenter}`}
    >
      <div className={variant === 'top' ? styles.iconWrapperTop : ''}>
        <div className={styles.iconContainer}>
          <div className={styles.iconBorder} />
          {characterImageUrl && (
            <div className={styles.iconMask}>
              <img
                src={characterImageUrl}
                alt="キャラクター"
                className={styles.iconImage}
              />
            </div>
          )}
        </div>
      </div>

      <div className={styles.dialogArea}>
        <div
          className={`${styles.dialogBox} ${variant === 'top' ? styles.dialogBoxTop : styles.dialogBoxCenter}`}
        >
          <div className={styles.dialogContent}>{children}</div>
        </div>
      </div>
    </div>
  );
};
